export { default } from './get-referrer';
export * from './get-referrer';
